module.exports = __webpack_public_path__ + "media/images/athletes/1796-91a854a07fe7e0ff7ec2111f1b414df6.png";